import { ORGANISATION } from './OrganisationActionTypes';

export const getAllOrganisationsAction = () => ({
	type: ORGANISATION.GET_ALL_ORGANISATIONS,
});

export const getAllStatesAction = () => ({
	type: ORGANISATION.GET_ALL_STATES,
});
